export default {
  desktop_access:
    '需要移动访问<br/><br/>要获得无缝的 Bitcash 钱包体验，请切换到您的移动设备。 我们建议您使用最新版本的移动浏览器。<br/><br/>支持的浏览器包括',
  desktop_access_2: '为了获得完全的兼容性和安全性，请使您的浏览器和移动设备保持最新状态。',
}
